import { Typography, Box, useTheme, useMediaQuery } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ListOperations({
  fetchOperations,
  operations,
  setSelectedRows,
  setListeTaskId,
  setListeTaskName,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: t('mesToDo.colName'),
          width: 210,
          // valueGetter: (params) => `${params.row.Nom?.Nom || params.row.IBAN}`,
          renderCell: (params) => (
            <Box py={2} mt={1}>
              <Box fontWeight={600}>{params.row.Name}</Box>
              <Box>
                <Box component={'span'}>{t('mesToDo.fieldDomain')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.LifeDomain ? params.row.domain.domain : ''}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>{t('mesToDo.fieldProject')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  0
                </Box>
              </Box>
            </Box>
          ),
        },
        {
          headerName: t('mesToDo.colTasks'),
          width: 130,
          type: 'number',
          renderCell: (params) => {
            let done = 0
            let taskslist = params.row.tasks
            taskslist.map((v) => {
              if (v.Done) done++
              return ''
            })
            let text = done + '/' + taskslist.length
            return <Box fontWeight={600}>{text}</Box>
          },
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    {
      field: 'Name',

      headerName: t('mesToDo.colName'),
      width: 650,
      editable: true,
      renderCell: (params) => params.row.Name,
    },
    {
      field: 'LifeDomain',
      headerName: t('mesToDo.fieldDomain'),
      width: 90,
      editable: true,
      valueGetter: (params) => `${params.row.LifeDomain ? params.row.domain.domain : ''}`,
    },
    {
      headerName: t('mesToDo.colTasks'),
      width: 80,
      editable: true,
      renderCell: (params) => {
        let done = 0
        let taskslist = params.row.tasks
        taskslist.map((v) => {
          if (v.Done) done++
          return ''
        })
        let text = done + '/' + taskslist.length
        return <Box>{text}</Box>
      },
    },

    {
      field: '',
      headerName: t('mesToDo.fieldProject'),
      width: 90,
      editable: true,
      renderCell: (params) => {
        return <Box>0</Box>
      },
    },
  ]

  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
        paddingBottom: 54,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('mesToDo.listsTitle', { count: operations.count })}
      </Typography>

      <DataGrid
        sx={{
          '.MuiDataGrid-footerContainer': { background: 'aliceblue' },
          '.MuiTablePagination-toolbar': { alignItems: 'baseline' },
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(params, event) => {
          if (event.target.localName === 'div') {
            setListeTaskId(params.id)
            setListeTaskName(params.row.Name)
            navigate('/todos/taches')
          }
        }}
      />
    </div>
  )
}
export default ListOperations
